import { unassignedPaymentsAtom } from "Payment/Atom/paymentAtom";
import { AllPaymentsTab } from "Payment/Components/Tabs/AllPaymentsTab";
import { UnassignedPaymentsTab } from "Payment/Components/Tabs/UnassignedPaymentsTab";
import type { TabType } from "Shared/Components/Tabs/Types/TabType";
import { Badge, Typography } from "@mui/material";
import { useAtom } from "jotai";

export enum PaymentTabs {
	unassigned = "unassigned",
	all = "all",
}

export const getPaymentTabs = (): TabType[] => {
	const [unassignedPayments] = useAtom(unassignedPaymentsAtom);

	const tabs: TabType[] = [
		{
			index: PaymentTabs.unassigned,
			label: (
				<Badge
					badgeContent={unassignedPayments}
					color="error"
					sx={{
						"& .MuiBadge-badge": {
							top: -2,
							right: -4,
						},
					}}
				>
					<Typography>Unassigned payments</Typography>
				</Badge>
			),
			tab: <UnassignedPaymentsTab />,
		},
		{
			index: PaymentTabs.all,
			label: <Typography>All payments</Typography>,
			tab: <AllPaymentsTab />,
		},
	];

	return tabs;
};
